import PropTypes from 'prop-types'
import DisplayError from 'components/commons/DisplayError/DisplayError'

const ErrorPage = ({ message, title, withButton }) => (
  <div className='full-height' data-testid='error-page'>
    <DisplayError
      title={title}
      message={message}
      onClick={() => window.location.reload()}
      withButton={withButton}
    />
  </div>
)

ErrorPage.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  withButton: PropTypes.bool
}

ErrorPage.defaultProps = {
  message: 'There was an error completing your request. Please Reload the Page.',
  title: 'Sorry, something went wrong',
  withButton: true
}

export default ErrorPage
